// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum PreferencesType {
  Preferences = 1,
  FirePreferences = 2,
  ESPreferences = 3,
  ProposalPreferences = 4,
  CollaboratorPreferences = 5,
  CostReviewerPreferences = 6,
  TaxDetailsPreferences = 7,
}
